module.exports = __webpack_public_path__ + "img/icon-link.41d568a0.svg";